import { useState } from "react";
import SeekerOnboardingModal from "./SeekerOnboardingModal";
import { useHistory } from "react-router-dom";

export default function SeekerTips() {
    const [showModal, setShowModal] = useState(true);
    const history = useHistory();

    const handleModalClose = () => {
        setShowModal(false);
        history.push(`${process.env.PUBLIC_URL}/seeker/dashboard`);
    };

    const handleFinish = () => {
        setShowModal(false);
        history.push(`${process.env.PUBLIC_URL}/seeker/dashboard`);
    };

    return (
        <div className="container p-0">
            <SeekerOnboardingModal
                show={showModal}
                onHide={handleModalClose}
                onFinish={handleFinish}
            />
        </div>
    );
}
